export default "__VITE_ASSET__whBNG2lS__"